import Icon from "@ant-design/icons";
import styled from "styled-components";
import { ReactComponent as IntercomPaidIcon } from "assets/icons/home/intercom-paid.svg";
import { useFeatureFlag } from "hooks/ui/useFeatureFlag";
import { Layers } from "legacy/constants/Layers";
import { Flag } from "store/slices/featureFlags";
import { IntercomPopover } from "./IntercomPopover";
import { INTERCOM_LAUNCHER_CLASSNAME } from "./constants";
import type React from "react";

const Circle = styled.div`
  height: 36px;
  width: 36px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.PLATFORM_BLACK};
  border-radius: 50%;
  display: inline-block;
  z-index: ${Layers.intercom};
  position: fixed;
  bottom: 12px;
  left: 12px;
  filter: drop-shadow(0 0 0.3rem rgba(85, 90, 99, 0.6));
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IntercomOverlay = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const enableIntercomLiveChat = useFeatureFlag(Flag.ENABLE_INTERCOM_LIVE_CHAT);
  const cloudpremIntercom = useFeatureFlag(Flag.CLOUDPREM_INTERCOM);

  // Hide Intercom bubble entirely if cloudprem flag is disabled or if feature flag is not enabled
  if (!cloudpremIntercom || !enableIntercomLiveChat) {
    return <div style={{ width: `100%`, height: "100%" }}>{children}</div>;
  }

  return (
    <div style={{ width: `100%`, height: "100%" }}>
      {children}
      <IntercomPopover>
        <Circle className={INTERCOM_LAUNCHER_CLASSNAME}>
          <Icon component={IntercomPaidIcon} style={{ fontSize: 18 }} />
        </Circle>
      </IntercomPopover>
    </div>
  );
};
